import React, { useContext } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Helmet } from "react-helmet-async";
  
import Button from "../components/Button";
import { SocketContext } from "../contexts/SocketContext";
import { timeAgo } from "../lib/time";

function Home(){  
  const { createRoom, joinedRooms } = useContext(SocketContext);

  const handleCreateRoom = () => {
    createRoom();
  };

  return (
    <div className='wrapper home'>
      <Helmet>
        <title>Home | Poker Planning</title>
        <meta name="description" content="Plan tasks with your team using fun and flexible poker planning cards. Create rooms, invite teammates, and keep your agile workflow smooth and collaborative." />
        <meta property="og:title" content="Welcome to Poker Planning!" />
      </Helmet>
      <Button className="button host-buttons home" onClick={handleCreateRoom}>Create a Room</Button>
      <p>Or join recently visited</p>
      <div className="home-recently-visited">
        {joinedRooms.map(item => <div className="home-joined-room" key={item.id}><Link to={`/${item.id}`}>{item.id} | {timeAgo(item.createdAt)}</Link></div>)}
      </div>
    </div>
  );
}
export default Home;
